import { render, staticRenderFns } from "./cotacoes.vue?vue&type=template&id=85292d00&"
import script from "./cotacoes.vue?vue&type=script&lang=js&"
export * from "./cotacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports